export interface PartnerItem {
    src: string;
    name: string;
    href: string;
}

export function partnerRows(data: any, lang: string): PartnerItem[] {
    const localized = data?.[lang]?.data;
    const rows = Array.isArray(localized) ? localized : data?.ko?.data;
    if (!Array.isArray(rows)) return [];
    return rows.map((item: any) => {
        if (typeof item === 'string') return { src: item, name: 'Partner', href: '' };
        if (!item || typeof item !== 'object') return null;
        const url = typeof item.url === 'string' ? item.url : '';
        const imageUrl = /^(data:image|\/)/i.test(url) || /\.(png|jpe?g|webp|svg|gif)(\?|$)/i.test(url);
        const src = item.src || item.logo || item.logoUrl || item.image || item.imageUrl || (imageUrl ? url : '');
        if (typeof src !== 'string' || !src.trim()) return null;
        const href = item.href || item.link || item.website || (!imageUrl ? url : '') || '';
        return {
            src,
            name: item.name || item.title || 'Partner',
            href: /^(https?:\/\/|\/)/i.test(href) ? href : ''
        };
    }).filter((item: PartnerItem | null) => item !== null) as PartnerItem[];
}
